import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DataComponent } from './data.component';
import { RespondentsModule } from '../respondents/respondents.module';
import { ReportsModule } from '../reports/reports.module';
import { DataNavbarModule } from '../dataNavBar/data-navbar.module';
import { TranslatePipeModule } from '../translate/translate.pipe.module';
import {StatisticsComponent} from './statistics.component';
import {RegisterDeviceModule} from '../deviceRegistrationModal/register-device.module';
import {GenericModalModule} from '../modal/generic-modal.module';
import {FileChooserModule} from '../FileChooser/file-chooser.module';
import {RegisterModule} from '../reportFilter/reportFilter.module';
import {CreateObjectDialogModule} from '../createObjectDialog/create-object-dialog.module';
import {EmailModule} from '../project/clientManager/client-manager.module';
import {NotificationModule} from '../notification/notification.module';
import {LoginCirclesModule} from '../loading-animation-2/loading-circles.module';
import {LoginModule} from '../loading-animation/loading.module';
@NgModule({
    imports: [CommonModule, RespondentsModule, ReportsModule, DataNavbarModule, TranslatePipeModule, LoginModule, RegisterDeviceModule, GenericModalModule, FileChooserModule, RegisterModule, CreateObjectDialogModule, EmailModule, NotificationModule, LoginCirclesModule],
  declarations: [DataComponent, StatisticsComponent],
  providers: [],
  exports: [DataComponent]
})
export class DataModule {

}
